module.exports = __webpack_public_path__ + "img/part-2-info-1.ee6cb84f.png";